import { PERMISSION_CODES } from '../../../constants/permissions';
import { ACTION_PLAN_FIELDS } from '../../../constants/actionPlan';
import { isArrayEmpty } from '../../../utility/helpers';
import { hasScopedAuthPermissionCheck } from '../../../utility/permissions';
import { formatDate } from '../../../utility/dateUtils';

export const INITIAL_SORT = {
  column: 'modifiedOn',
  asc: false,
  sortKey: '-modified_on',
};

export const getHeaderActions = labels => [
  {
    id: 'actions-column',
    title: labels.actions,
    rowKey: 'actions',
    align: 'right',
    rowCellClass: 'actions-cell',
    isHeaderAction: true,
    minWidth: 60,
    maxWidth: 80,
  },
];

export const getTableHeaders = labels => [
  {
    id: 1,
    title: labels.name,
    rowKey: 'name',
    sortAs: 'user__first_name,user__last_name',
    rowCellClass: 'created-for-cell',
    minWidth: '160px',
    maxWidth: '1fr',
  },
  {
    id: 2,
    title: labels.title,
    rowKey: 'title',
    sortAs: 'title',
    rowCellClass: 'title-cell',
    minWidth: 145,
    maxWidth: '1fr',
    hasConditionalTooltip: true,
  },
  {
    id: 3,
    title: labels.dueDate,
    rowKey: 'dueDate',
    rowCellClass: 'due-date-cell',
    sortAs: 'due_date',
    maxWidth: '1fr',
  },
  {
    id: 4,
    title: labels.modifiedOn,
    rowKey: 'modifiedOn',
    rowCellClass: 'modified-on-cell',
    sortAs: 'modified_on',
    maxWidth: '1fr',
  },
  {
    id: 5,
    title: labels.status,
    rowKey: 'status',
    sortAs: 'is_finished',
    maxWidth: '1fr',
  },
];

export const prepareTableData = (
  actionPlans,
  currentUser,
  accessControl,
  statuses,
  renderUser,
  renderStatus,
  renderActions
) => {
  const {
    TITLE,
    USER,
    STATUS,
    DUE_DATE,
    MODIFIED_ON,
    TASKS,
    PROGRESS,
    COURSES,
    IS_PROPOSED,
    IS_PENDING_PROPOSAL,
  } = ACTION_PLAN_FIELDS;

  return actionPlans.map(actionPlan => {
    const detailsUrl = `${actionPlan.id}/details/`;
    const status = statuses.find(s => {
      return s.value === actionPlan[STATUS];
    });
    const hasTasks = !isArrayEmpty(actionPlan[TASKS]);
    const isProposed = actionPlan[IS_PROPOSED];
    const isPendingProposal = isProposed && actionPlan[IS_PENDING_PROPOSAL];
    const isCreatedForCurrentUser = actionPlan[USER].id === currentUser.id;
    const canManageOwnPendingProposal =
      isPendingProposal && isCreatedForCurrentUser;
    const isCurrentPlanManagable = hasScopedAuthPermissionCheck(
      PERMISSION_CODES.PLANS_EDIT,
      accessControl,
      currentUser.id,
      actionPlan[USER].id
    );
    const isCurrentPlanDeletable = hasScopedAuthPermissionCheck(
      PERMISSION_CODES.PLANS_DELETE,
      accessControl,
      currentUser.id,
      actionPlan[USER].id
    );
    const canManage = isCurrentPlanManagable || canManageOwnPendingProposal;
    const canDelete = isCurrentPlanDeletable || canManageOwnPendingProposal;

    return {
      ...(canManage || canDelete || isCreatedForCurrentUser
        ? {
            actions: renderActions(
              actionPlan,
              canManage,
              canDelete,
              isPendingProposal,
              isCreatedForCurrentUser
            ),
          }
        : {}),
      id: actionPlan.id,
      name: renderUser(
        actionPlan[USER],
        !isPendingProposal && isProposed,
        isCreatedForCurrentUser
      ),
      title: actionPlan[TITLE],
      dueDate: formatDate(actionPlan[DUE_DATE]),
      modifiedOn: formatDate(actionPlan[MODIFIED_ON]),
      status: renderStatus(
        status,
        actionPlan[PROGRESS],
        hasTasks,
        actionPlan[COURSES],
        isPendingProposal
      ),
      rowLink: detailsUrl,
    };
  });
};
